module.exports = __webpack_public_path__ + "static/media/game_background.12eda7d0.png";